import { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { onSubmit } from ".";
import { ApiContext } from "../../context/ApiContext";
import ContentModal from "../../shared/Modal";
import { FormInputs } from "../../types/types";
import __ from "../../utils/getContent";
import CheckboxField from "../fields/checkboxField";
import RadioGroupField from "../fields/radioGroupField";

// Extend the Window interface to include midtownMembershipsLanguage
declare global {
	interface Window {
		midtownMembershipsLanguage?: {
			current_language?: string;
		};
	}
}

const ContractInterstitial = ({ closeModal }: { closeModal: () => void }) => {
	const { watch, handleSubmit } = useFormContext<FormInputs>();

	const navigate = useNavigate();
	const { data, setData } = useContext(ApiContext);

	const selectedLanguage = watch("member.contractLanguage");
	const lang = window?.midtownMembershipsLanguage?.current_language ?? "en";

	useEffect(() => {
		if (selectedLanguage) {
			setData({
				...data,
				language: selectedLanguage,
			});
		} else {
			setData({
				...data,
				language: lang,
			});
		}
	}, [selectedLanguage, setData]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div>
			{data?.get_contract?.MembershipContractContent && (
				<>
					<ContentModal
						isOpen={true}
						closeModal={closeModal}
						contentLabel={__("membership_agreement", "Membership Agreement")}
						customStyles={{
							content: {
								bottom: "auto",
								height: "86vh",
								width: "86vw",
								left: "50%",
								position: "fixed",
								right: "auto",
								top: "50%",
								transform: "translate(-50%,-50%)",
								padding: "0",
								paddingLeft: "2rem",
								borderRadius: "0",
							},
						}}
					>
						<form
							onSubmit={handleSubmit(onSubmit)}
							className="mb-5 w-full pt-4"
						>
							<CheckboxField
								registeredName="member.hasInitialConfirmedContract"
								isRequired={false}
								label={__(
									"agree_to_terms",
									"I agree to the membership terms and conditions",
								)}
								onChange={(event) => {
									event.target.checked && navigate("?step=summary");
								}}
								wrapperClass="pr-10"
							/>
							<div className="-ml-2 w-44">
								<RadioGroupField
									registeredName="member.contractLanguage"
									isRequired={false}
									label={__("input_select_language_label", "Select Language")}
									isClustered={true}
									defaultValue={lang}
									radios={[
										{
											id: "contractLanguageEn",
											label: "En",
											value: "en",
										},
										{
											id: "contractLanguageFr",
											label: "Fr",
											value: "fr",
										},
									]}
								/>
							</div>
						</form>
						<iframe
							title={__(
								"membership_terms_and_conditions",
								"Membership Terms and Conditions",
							)}
							width="100%"
							height="85%"
							srcDoc={
								selectedLanguage && selectedLanguage === "fr"
									? data?.get_contract_fr?.MembershipContractContent
									: data?.get_contract?.MembershipContractContent
							}
						/>
					</ContentModal>
				</>
			)}
		</div>
	);
};

export default ContractInterstitial;
